import {IStateSearch} from './reducer';
import {
  createAction,
  createActionFetch,
  createBasicActions,
} from '../../common/util/redux';
import {ISearchResult, ISearchType} from '../type';

export enum ActionType {
  SetValue = 'search.SetValue',
  SetPropertyValues = 'search.SetPropertyValues',
  FetchGenres = 'search.FetchGenres',
  FetchSuggest = 'search.FetchSuggest',
  ResetResult = 'search.ResetResult',
  FetchResult = 'search.FetchResult',
  AddResult = 'search.AddResult',
}

export const actions = {
  ...createBasicActions<IStateSearch>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  fetchGenres: () => createActionFetch(ActionType.FetchGenres),
  fetchSuggest: (keyword: string) =>
    createActionFetch(ActionType.FetchSuggest, {payload: {keyword}}),
  resetResult: () => createActionFetch(ActionType.ResetResult),
  fetchResult: (
    data: {keyword: string; type?: ISearchType},
    isFirst?: boolean
  ) =>
    createActionFetch(ActionType.FetchResult, {
      payload: data,
      isFirst,
    }),
  addResult: (result: ISearchResult, isFirst?: boolean) =>
    createAction(ActionType.AddResult, {
      result,
      isFirst,
    }),
};
